<script>
import { customerService } from "@/helpers/services/customer.service";
import { sharedHelper } from "@/utils";

// Public page reached from the customer (patient) set-password / verification
// email link. Completing it sets the password AND verifies the account.
export default {
  page: { title: "Set Password" },
  data() {
    return {
      email: this.$route.query.email || "",
      token: this.$route.query.token || "",
      password: "",
      passwordConfirmation: "",
      submitted: false,
      processing: false,
      done: false,
    };
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  computed: {
    passwordError() {
      if (!this.submitted) return "";
      if (!this.password) return "Password is required.";
      if (this.password.length < 8 || this.password.length > 20)
        return "Password must be 8-20 characters.";
      return "";
    },
    confirmError() {
      if (!this.submitted) return "";
      if (this.passwordConfirmation !== this.password)
        return "Passwords do not match.";
      return "";
    },
    linkInvalid() {
      return !this.token || !this.email;
    },
  },
  methods: {
    async submit() {
      this.submitted = true;
      if (this.passwordError || this.confirmError) return;

      this.processing = true;
      try {
        await customerService.setCustomerPassword({
          email: this.email,
          token: this.token,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        });
        this.done = true;
      } catch (e) {
        sharedHelper.alertErrorMessage(
          sharedHelper.getErrorMessage(e),
          e?.response?.data?.code
        );
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row no-gutters">
        <div class="col-lg-4">
          <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
            <div class="w-100">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <div class="text-center">
                    <a href="/" class="logo">
                      <img src="https://getbase.s3.ap-southeast-1.amazonaws.com/Techventis+Medic+Sdn+Bhd.png" style="height: 30%; width: 30%;" alt="logo" />
                    </a>
                    <h4 class="font-size-18 mt-4">Set your password</h4>
                    <p class="text-muted">Choose a password to activate your account.</p>
                  </div>

                  <div class="p-2 mt-4">
                    <div v-if="linkInvalid" class="alert alert-danger">
                      This link is invalid or incomplete. Please use the link from your email.
                    </div>

                    <div v-else-if="done" class="text-center">
                      <i class="ri-checkbox-circle-line text-success" style="font-size: 56px;"></i>
                      <h5 class="mt-3">Password set</h5>
                      <p class="text-muted">Your account is verified. You can now log in from the app.</p>
                    </div>

                    <form v-else class="form-horizontal" @submit.prevent="submit">
                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-mail-line auti-custom-input-icon"></i>
                        <label>Email</label>
                        <input v-model="email" type="email" class="form-control" readonly />
                      </div>

                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-lock-2-line auti-custom-input-icon"></i>
                        <label for="password">Password</label>
                        <input v-model="password" type="password" id="password" class="form-control"
                          :class="{ 'is-invalid': passwordError }" placeholder="Enter password" />
                        <div v-if="passwordError" class="invalid-feedback d-block">{{ passwordError }}</div>
                      </div>

                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-lock-2-line auti-custom-input-icon"></i>
                        <label for="confirm">Confirm password</label>
                        <input v-model="passwordConfirmation" type="password" id="confirm" class="form-control"
                          :class="{ 'is-invalid': confirmError }" placeholder="Re-enter password" />
                        <div v-if="confirmError" class="invalid-feedback d-block">{{ confirmError }}</div>
                      </div>

                      <div class="mt-4 text-center">
                        <button class="btn btn-primary w-md waves-effect waves-light" type="submit" :disabled="processing">
                          {{ processing ? "Saving..." : "Set password" }}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div class="mt-5 text-center">
                    <p>© {{ new Date().getFullYear() }} {{ $t('projectName') }}.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="authentication-bg">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
